import Slide1 from 'src/assets/svg/slide-1.svg';
import Slide2 from 'src/assets/svg/slide-2.svg';
import Slide3 from 'src/assets/svg/slide-3.svg';

export const slides = [
  {
    title: 'slide1.title',
    description: 'slide1.description',
    image: Slide1,
    altText: 'slide1.altText',
  },
  {
    title: 'slide2.title',
    description: 'slide2.description',
    image: Slide2,
    altText: 'slide2.altText',
  },
  {
    title: 'slide3.title',
    description: 'slide3.description',
    image: Slide3,
    altText: 'slide3.altText',
  },
];
